import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@/lib/api-client";

export type MasterPeriode = {
  master_periode_id: number;
  is_aktif: number;
  tahun: string;
  semester: number;
  pir: number;
  can_change: number;
  is_sinkron: number;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
};

export const fetchMasterPeriode = async (): Promise<MasterPeriode[]> => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;

  return apiClient<MasterPeriode[]>(`${baseUrl}/api/v1/master-periode`, {
    headers: {
      Accept: "application/json",
    },
  });
};

export const useMasterPeriode = (options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: ["master-periode"],
    queryFn: fetchMasterPeriode,
    ...options,
  });
};

export const updateMasterPeriodePir = async ({
  id,
  pir,
}: {
  id: number;
  pir: number;
}) => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;

  return apiClient<any>(`${baseUrl}/api/v1/master-periode/${id}`, {
    method: "POST",
    headers: {
      Accept: "application/json",
    },
    body: JSON.stringify({ pir }),
  });
};

export const useUpdateMasterPeriodePir = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateMasterPeriodePir,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["master-periode"] });
    },
  });
};

export const copyPeriode = async ({
  source_periode_id,
  target_periode_id,
}: {
  source_periode_id: number;
  target_periode_id: number;
}) => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;

  return apiClient<any>(`${baseUrl}/api/v1/copy-periode`, {
    method: "POST",
    headers: {
      Accept: "application/json",
    },
    body: JSON.stringify({ source_periode_id, target_periode_id }),
  });
};

export const useCopyPeriode = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: copyPeriode,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["master-periode"] });
    },
  });
};
